/* eslint-disable no-param-reassign */
/* eslint:disable */
import {
  Getters,
  Mutations,
  Actions,
  Module,
  createMapper,
} from 'vuex-smart-module';

class RocketChatState {
  setup = {
    widgetUrl: '//chat.marathonbet.by/livechat',
    scriptName: 'rocketchat-livechat.min.js',
    scriptVersion: '201903270000',
  };
}

class RocketChatGetters extends Getters<RocketChatState> {
  get setup() {
    return this.state.setup;
  }
}

class RocketChatMutations extends Mutations<RocketChatState> {
}

class RocketChatActions extends Actions<
  RocketChatState,
  RocketChatGetters,
  RocketChatMutations,
  RocketChatActions
  > {
}

// Экспорт модуля
export const RocketChatModule = new Module({
  state: RocketChatState,
  getters: RocketChatGetters,
  mutations: RocketChatMutations,
  actions: RocketChatActions,
});

export const RocketChatModuleMapper = createMapper(RocketChatModule);
